import { type FC } from "react";

import { clsx } from "clsx";

import { type AssistantChatMessageModel } from "../model";

import styles from "./AssistantChatMessageItem.module.css";

interface Props {
    message: AssistantChatMessageModel;
}

export const UserMessageItem: FC<Props> = ({ message }) => (
    <div className={clsx(styles.row, styles.user)}>
        <div className={styles.capsule}>{message.text}</div>
    </div>
);
